import * as tslib_1 from "tslib";
/*
 * @Descripttion:
 * @version: v1.0
 * @Author: baidongsheng
 * @Date: 2021-09-06 17:37:05
 * @LastEditors: baidongsheng
 * @LastEditTime: 2021-09-07 22:02:46
 */
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import System from './modules/system/index';
import WorkflowCenter from './modules/workflow-center/index';
import { bizpropertyApi } from "@cloudpivot/api";
import { listApi } from '@cloudpivot/api';
const vuexLocal = new VuexPersistence({
    key: 'vuex',
    storage: localStorage,
    reducer: (state) => ({
        appCode: state.appCode
    })
});
Vue.use(Vuex);
export default new Vuex.Store({
    namespace: true,
    state: {
        appCode: '',
        config: {},
        formRuleList: [],
        singleAppGroups: [],
        motalflag: null,
    },
    mutations: {
        setAppGroups(state, singleAppGroups) {
            state.singleAppGroups = null;
            state.singleAppGroups = singleAppGroups;
        },
        setAppCode(state, appCode) {
            state.appCode = appCode;
        },
        setConfig(state, config) {
            state.config = config;
        },
        setFormRuleList(state, val) {
            state.formRuleList = val;
        },
        setMotalflag(state, flag) {
            state.motalflag = flag;
        }
    },
    actions: {
        getAppGroups({ commit, state }, param) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const res = yield listApi.getFolder(param);
                if (res.errcode === 0) {
                    if (!Array.isArray(res.data)) {
                        return;
                    }
                    commit('setAppGroups', res.data);
                }
            });
        },
        getFormRuleList({ commit, state }, param) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const params = {
                    schemaCode: param.bizSchemaCode
                };
                const res = yield bizpropertyApi.getDataRules(params);
                if (res.errcode === 0) {
                    commit('setFormRuleList', res.data);
                }
            });
        },
    },
    modules: {
        WorkflowCenter,
        System
    },
    plugins: [vuexLocal.plugin]
});
